export const playgroundSteps = ['materials', 'stuck', 'drop', 'foundations', 'joint', 'adults', 'instructions'];

export const playgroundItems = [
  {
    title: 'swings',
    items: ['seat', 'suspension', 'freeSpace', 'ropeLength', 'floor'],
  },
  {
    title: 'slides',
    items: ['surface', 'sides', 'areas', 'freeSpace', 'floor'],
  },
  {
    title: 'climb',
    items: ['frame', 'grap', 'net', 'one', 'floor'],
  },
  {
    title: 'carousel',
    items: ['rolling', 'ground', 'seats', 'floor'],
  },
  {
    title: 'bounce',
    items: ['mat', 'suspension', 'height', 'ground', 'blocking', 'hurdles'],
  },
];
